export const environment = {
  production: true,
  azureAdClientId: '6c699c1a-72ec-491d-b044-059a0997928c',
  apiPortalPais: 'https://portalpaisapi.virescoerp.com.br',
  apiSaguiControl: 'https://saguicontrolapi.azurewebsites.net',
  apiSaguiEdu: 'https://saguieduapi.azurewebsites.net',
  getNetScript: 'https://checkout.getnet.com.br/loader.js?4dtgq0u7nwe',
  getNetSellerId: 'b485890b-5ca5-4470-a94c-5acdda0ebc41',
  scopes: ['https://saguitechb2c.onmicrosoft.com/8be9481b-b76f-457d-aaba-84fc7a4cd91a/PortalPais.Read'],
  loginUrl: 'https://portalpais.virescoerp.com.br/'
};

  // production: false,
  // azureAdClientId: '6c699c1a-72ec-491d-b044-059a0997928c', // cliente Id do Portal Pais SPA
  // apiSaguiControl: 'https://localhost:44327',
  // apiSaguiControlParceiro: 'https://localhost:7127',
  // apiSaguiControlConta: 'https://localhost:7188',
  // apiSaguiEduAluno: 'https://localhost:7064',
  // apiSaguiEdu: 'https://localhost:44330',
  // apiPortalPais: 'https://localhost:44339',
  // getNetScript: 'https://checkout.getnet.com.br/loader.js?4dtgq0u7nwe',
  // getNetSellerId: 'b485890b-5ca5-4470-a94c-5acdda0ebc41',
  // scopes: ['https://saguitechb2c.onmicrosoft.com/8be9481b-b76f-457d-aaba-84fc7a4cd91a/PortalPais.Read']

